<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12">
				<div class="box">
					<div>
						<label>{{ $t('client_area.contract_privacy.contract_validation') }}</label>

						<b-input-group prepend="FR">
							<b-form-input
								class="mr-1"
								v-model="privacy_policy_content"
								:placeholder="$t('client_area.contract_privacy.contract_validation_placeholder_fr')"
							></b-form-input>
						</b-input-group>
						
						<b-input-group prepend="EN" class="mt-2">
							<b-form-input
								class="mr-1"
								v-model="privacy_policy_content_en"
								:placeholder="$t('client_area.contract_privacy.contract_validation_placeholder_en')"
							></b-form-input>
						</b-input-group>
					</div>

					<div class="pt-4">
						<label>{{ $t('client_area.contract_privacy.cgv_link') }}</label>

						<b-input-group prepend="FR">
							<b-form-input
								class="mr-1"
								v-model="cgv_link"
								:placeholder="$t('client_area.contract_privacy.cgv_link_placeholder_fr')"
							></b-form-input>
						</b-input-group>

						<b-input-group prepend="EN" class="mt-2">
							<b-form-input
								class="mr-1"
								v-model="cgv_link_en"
								:placeholder="$t('client_area.contract_privacy.cgv_link_placeholder_en')"
							></b-form-input>
						</b-input-group>
					</div>

					<div class="pt-4">
						<label>{{ $t('client_area.contract_privacy.link_privacy_policy') }}</label>
			
						<b-input-group prepend="FR">
							<b-form-input
								class="mr-1"
								v-model="privacy_link"
								:placeholder="$t('client_area.contract_privacy.link_privacy_policy_placeholder_fr')"
							></b-form-input>
						</b-input-group>

						<b-input-group prepend="EN" class="mt-2">
							<b-form-input
								class="mr-1"
								v-model="privacy_link_en"
								:placeholder="$t('client_area.contract_privacy.link_privacy_policy_placeholder_en')"
							></b-form-input>
						</b-input-group>
					</div>

					<div class="pt-4">
						<label>{{ $t('client_area.contract_privacy.message_no_condition') }}</label>
			
						<b-input-group prepend="FR">
							<b-form-input
								class="mr-1"
								v-model="message_conditions"
								:placeholder="$t('client_area.contract_privacy.message_no_condition_placeholder_fr')"
							></b-form-input>
						</b-input-group>

						<b-input-group prepend="EN" class="mt-2">
							<b-form-input
								class="mr-1"
								v-model="message_conditions_en"
								:placeholder="$t('client_area.contract_privacy.message_no_condition_placeholder_en')"
							></b-form-input>
						</b-input-group>
					</div>

					<div class="pt-4">
						<b-form-checkbox v-model="contract_allow_discount">
							{{ $t('client_area.contract_privacy.allow_discount') }}
						</b-form-checkbox>
					</div>

					<div class="pt-3">
						<b-form-checkbox v-model="use_electronic_signature">
							{{ $t('client_area.contract_privacy.use_electronic_signature') }}
						</b-form-checkbox>
					</div>

					<div class="pt-3">
						<b-form-checkbox v-model="allow_payment_later">
							{{ $t('client_area.contract_privacy.allow_payment_later') }}
						</b-form-checkbox>
					</div>

					<div class="pt-4">
						<label>{{ $t('client_area.contract_privacy.allowed_countries') }}</label>
						<e-select
							v-model="allowed_countries"
							track-by="id"
							label="name"
							:options="countries_options"
							:searchable="true"
							:multiple="true"
							:close-on-select="false"
							:show-labels="false"
							:placeholder="$t('client_area.contract_privacy.allowed_countries_placeholder')"
						>
							<template slot="noOptions">{{ $t('global.list_empty') }}</template>
						</e-select>
					</div>

					<div class="pt-4">
						<label>{{ $t('client_area.contract_privacy.date_ouverture') }}</label>
			
						<div class="row">
							<div class="col-6">
								<div class="w-100">
									<b-input-group class="w-100" :prepend="getTrad('client_area.contract_privacy.debut')">
										<e-datepicker v-model="start_contract"></e-datepicker>
									</b-input-group>
								</div>
							</div>
							<div class="col-6">
								<div class="w-100">
									<b-input-group class="w-100" :prepend="getTrad('client_area.contract_privacy.fin')">
										<e-datepicker v-model="end_contract"></e-datepicker>
									</b-input-group>
								</div>
							</div>
						</div>


						<b-input-group :prepend="getTrad('client_area.contract_privacy.text_contract')" class="mt-2">
							<b-form-input
								class="mr-1"
								v-model="text_contract"
								:placeholder="$t('client_area.contract_privacy.text_contract')"
							></b-form-input>
						</b-input-group>
					</div>


					<div class="pt-4">
						<label>{{ $t('client_area.contract_privacy.welcome_message') }}</label>

						<div class="mb-1 mt-1">
							<small class="text-muted">FR</small>
							<e-editor-froala
								v-if="data_loaded"
								identifier="welcome_message_fr"
								:content="welcome_message_fr"
								@change="welcome_message_fr = $event.val"
								:moreText="[ 'bold', 'italic', 'underline', 'strikeThrough', 'formatUL', 'formatOL', 'clearFormatting', 'undo', 'redo' ]"
							></e-editor-froala>
						</div>

						<div class="mt-2">
							<small class="text-muted">EN</small>
							<e-editor-froala
								v-if="data_loaded"
								identifier="welcome_message_en"
								:content="welcome_message_en"
								@change="welcome_message_en = $event.val"
								:moreText="[ 'bold', 'italic', 'underline', 'strikeThrough', 'formatUL', 'formatOL', 'clearFormatting', 'undo', 'redo' ]"
							></e-editor-froala>
						</div>
					</div>

					<div class="pt-4">
						<label>{{ $t('client_area.contact_us.contactus') }}</label>

						<div class="mb-1 mt-1">
							<small class="text-muted">FR</small>
							<e-editor-froala
								v-if="data_loaded"
								identifier="contactus_fr"
								:content="contactus_fr"
								@change="contactus_fr = $event.val"
								:moreText="[ 'bold', 'italic', 'underline', 'strikeThrough', 'formatUL', 'formatOL', 'clearFormatting', 'undo', 'redo' ]"
							></e-editor-froala>
						</div>

						<div class="mt-2">
							<small class="text-muted">EN</small>
							<e-editor-froala
								v-if="data_loaded"
								identifier="contactus_en"
								:content="contactus_en"
								@change="contactus_en = $event.val"
								:moreText="[ 'bold', 'italic', 'underline', 'strikeThrough', 'formatUL', 'formatOL', 'clearFormatting', 'undo', 'redo' ]"
							></e-editor-froala>
						</div>
					</div>

					<div class="pt-4">
						<label>{{ $t('client_area.contact_us.openhours') }}</label>
						<div v-for="(hours, idx) in openDays" :key="idx" class="mt-1">
							<b-input-group :prepend="day_names[idx]">
								<b-form-input
									:value="openDays[idx]"
									@input="$set(openDays, idx, $event)"
									placeholder="09:00-12:00, 14:00-18:00"
								></b-form-input>
							</b-input-group>
						</div>
					</div>

					<div class="pt-4">
						<label>{{ $t('client_area.contract_privacy.notification_from_email') }}</label>
						<e-select
							v-model="notification_from_email"
							:options="from_email_options"
							:searchable="true"
							:taggable="true"
							:placeholder="$t('client_area.contract_privacy.notification_from_email_placeholder')"
							:show-labels="false"
							@tag="notification_from_email = $event"
						>
							<template slot="noOptions">{{ $t('global.list_empty') }}</template>
						</e-select>
					</div>

					<div class="pt-4">
						<label>{{ $t('client_area.contract_privacy.notification_to_email') }}</label>
						<b-form-input
							v-model="notification_to_email"
							type="email"
							:placeholder="$t('client_area.contract_privacy.notification_to_email_placeholder')"
						></b-form-input>
					</div>

					<!-- Test d'envoi de l'email de notification admin -->
					<div class="pt-4 border rounded p-3 bg-light">
						<label class="font-weight-bold">{{ $t('client_area.contract_privacy.test_admin_notif_email') }}</label>
						<p class="text-muted small mb-2">{{ $t('client_area.contract_privacy.test_admin_notif_email_help') }}</p>
						<div class="d-flex align-items-center">
							<b-form-input
								v-model="test_contract_id"
								type="number"
								class="mr-2"
								style="max-width: 200px;"
								:placeholder="$t('client_area.contract_privacy.test_admin_notif_contract_id')"
							></b-form-input>
							<button
								class="btn btn-outline-secondary"
								:disabled="!test_contract_id || test_sending"
								@click="sendTestAdminNotifMail"
							>
								<span v-if="test_sending">
									<b-spinner small></b-spinner>
								</span>
								<span v-else>{{ $t('client_area.contract_privacy.test_admin_notif_send') }}</span>
							</button>
						</div>
					</div>

					<!-- Test d'envoi de l'email de confirmation au client -->
					<div class="pt-4 border rounded p-3 bg-light mt-3">
						<label class="font-weight-bold">{{ $t('client_area.contract_privacy.test_client_notif_email') }}</label>
						<p class="text-muted small mb-2">{{ $t('client_area.contract_privacy.test_client_notif_email_help') }}</p>
						<div class="d-flex align-items-center flex-wrap">
							<b-form-input
								v-model="test_client_contract_id"
								type="number"
								class="mr-2 mb-2"
								style="max-width: 200px;"
								:placeholder="$t('client_area.contract_privacy.test_admin_notif_contract_id')"
							></b-form-input>
							<b-form-input
								v-model="test_client_email_override"
								type="email"
								class="mr-2 mb-2"
								style="max-width: 260px;"
								:placeholder="$t('client_area.contract_privacy.test_client_notif_email_override')"
							></b-form-input>
							<button
								class="btn btn-outline-secondary mb-2"
								:disabled="!test_client_contract_id || test_client_sending"
								@click="sendTestClientNotifMail"
							>
								<span v-if="test_client_sending">
									<b-spinner small></b-spinner>
								</span>
								<span v-else>{{ $t('client_area.contract_privacy.test_client_notif_send') }}</span>
							</button>
						</div>
					</div>

					<div class="mt-4 col-12">
						<div class="form-group text-center">
							<button class="btn btn-primary" @click='save_privacy_settings'>
								{{$t("global.sauvegarder")}}
							</button>
						</div>
					</div>
				</div>	
			</div>
		</div>
	</div>
</template>


<script type="text/javascript">
	import _defaults from 'lodash/defaults'
	import Vue from 'vue'
	import Countries from 'GroomyRoot/assets/lang/countries/countries'
	import Contract from "@/mixins/Contract.js"
	import Model from "@/mixins/Model.js"

	export default {
		name: "CguCgv",
		mixins: [Contract, Model],
		data () {
			return {
				privacy_policy_content: '',
				privacy_policy_content_en: '',
				cgv_link: '',
				cgv_link_en: '',
				privacy_link: '',
				privacy_link_en: '',
				message_conditions: '',
				message_conditions_en: '',
				start_contract: null,
				end_contract: null,
				text_contract: '',
				contract_allow_discount: true,
				use_electronic_signature: false,
				allow_payment_later: true,
				allowed_countries: [],
				welcome_message_fr: '',
				welcome_message_en: '',
				contactus_fr: '',
				contactus_en: '',
				openDays: ['', '', '', '', '', '', ''],
				notification_from_email: '',
				notification_to_email: '',
				from_email_options: [],
				test_contract_id: '',
				test_sending: false,
				test_client_contract_id: '',
				test_client_email_override: '',
				test_client_sending: false,
				data_loaded: false,
			}
		},
		created() {
			this.preinit_component()
		},
		computed: {
			/**
			 * Noms des jours de la semaine traduits (lundi → dimanche).
			 * @returns {string[]}
			 */
			day_names() {
				return this.$t('client_area.contact_us.days')
			},
			countries_options() {
				const locale = Vue.i18n.locale()
				const data = Countries[locale] || Countries['fr']
				const labels = data.label
				const iso3 = data.iso_3
				return Object.keys(labels)
					.map(id => ({ id: parseInt(id), name: labels[id] + ' - ' + iso3[id] }))
					.sort((a, b) => {
						const x = a.name.toLowerCase()
						const y = b.name.toLowerCase()
						return x < y ? -1 : x > y ? 1 : 0
					})
			},
		},
		methods: {
			async preinit_component() {
				const [ca_config, welcome, contact] = await Promise.all([
					this.getCaContractPrivacyPolicy(),
					this.getCaWelcomeMessage(),
					this.getCaContactUs(),
				])

				const temp = _defaults(ca_config, {
					privacy_policy_content: '',
					privacy_policy_content_en: '',
					cgv_link: '',
					cgv_link_en: '',
					privacy_link: '',
					privacy_link_en: '',
					message_conditions: '',
					message_conditions_en: '',
					start_contract: null,
					end_contract: null,
					text_contract: '',
					contract_allow_discount: true,
					use_electronic_signature: false,
					allow_payment_later: true,
					allowed_countries: [],
					notification_from_email: '',
					notification_to_email: '',
				})

				const rawCountries = temp.allowed_countries || []
				delete temp.allowed_countries

				Object.keys(temp).forEach(k => {
					this[k] = temp[k]
				})

				this.allowed_countries = rawCountries
					.map(id => this.countries_options.find(c => c.id == id))

				this.welcome_message_fr = welcome.welcome_message_fr
				this.welcome_message_en = welcome.welcome_message_en
				this.contactus_fr = contact.contactus_fr
				this.contactus_en = contact.contactus_en
				this.openDays = contact.openDays

				await this.loadFromEmailOptions()
				this.data_loaded = true
			},

			/**
			 * Charge les adresses email d'expédition configurées pour la licence et peuple from_email_options.
			 */
			async loadFromEmailOptions() {
				const from_address = await this.loadAllFromAddress()
				if (!from_address) return

				const entries = Object.values(from_address).filter(from => from.licenceconfig_value)
				const hasValidLicenceKey = entries.filter(item => item.licenceconfig_licencekey !== null && item.licenceconfig_key === 'from_address')
				const addressEntries = hasValidLicenceKey.length > 0 ? hasValidLicenceKey : entries.filter(item => item.licenceconfig_key === 'from_address')

				const emails = []
				for (const entry of addressEntries) {
					if (entry.licenceconfig_value) {
						const values = entry.licenceconfig_value.split(',')
						for (const val of values) {
							const trimmed = val.trim()
							if (trimmed && !emails.includes(trimmed)) {
								emails.push(trimmed)
							}
						}
					}
				}

				this.from_email_options = emails
				if (this.notification_from_email && !emails.includes(this.notification_from_email)) {
					this.from_email_options.unshift(this.notification_from_email)
				}
			},

			save_privacy_settings() {
				Promise.all([
					this.saveCaContractPrivacyPolicy({
						privacy_policy_content	 : this.privacy_policy_content,
						privacy_policy_content_en: this.privacy_policy_content_en,
						cgv_link	: this.cgv_link,
						cgv_link_en : this.cgv_link_en,
						privacy_link: this.privacy_link,
						privacy_link_en: this.privacy_link_en,
						message_conditions: this.message_conditions,
						message_conditions_en: this.message_conditions_en,
						start_contract: this.start_contract,
						end_contract: this.end_contract,
						text_contract: this.text_contract,
						contract_allow_discount: this.contract_allow_discount,
						use_electronic_signature: this.use_electronic_signature,
						allow_payment_later: this.allow_payment_later,
						allowed_countries: this.allowed_countries.map(c => c.id),
						notification_from_email: this.notification_from_email,
						notification_to_email: this.notification_to_email,
					}),
					this.saveCaWelcomeMessage(this.welcome_message_fr, this.welcome_message_en),
					this.saveCaContactUs(this.contactus_fr, this.contactus_en, this.openDays),
				]).then(() => {
					this.successToast()
				})
			},

			async sendTestAdminNotifMail() {
				this.test_sending = true
				try {
					await this.sendTestCaAdminNotifMail(this.test_contract_id)
					this.successToast('client_area.contract_privacy.test_admin_notif_success')
				} catch(e) {
					this.failureToast('client_area.contract_privacy.test_notif_error', { error: e.message || e })
				} finally {
					this.test_sending = false
				}
			},

			async sendTestClientNotifMail() {
				this.test_client_sending = true
				try {
					const res = await this.sendTestCaClientNotifMail(this.test_client_contract_id, this.test_client_email_override || null)
					const sentTo = res && res.email ? res.email : ''
					if (sentTo) {
						this.successToast('client_area.contract_privacy.test_client_notif_success_to', { email: sentTo })
					} else {
						this.successToast('client_area.contract_privacy.test_client_notif_success')
					}
				} catch(e) {
					this.failureToast('client_area.contract_privacy.test_notif_error', { error: e.message || e })
				} finally {
					this.test_client_sending = false
				}
			}
		}
	}
</script>
